module.exports = __webpack_public_path__ + "img/TransferLower1Page.b92e4ab0.png";